import React, { useEffect, useRef } from "react";
import { NavDropdown } from "react-bootstrap";
import Translator from "../helper/Translate";
import { changeLanguagePreferenceAction, selectLanguageAction } from "../redux/language/language.actions";
import { useDispatch, useSelector } from "react-redux";
import { getInitialLanguage, LANGUAGES } from "../helper/language";

const LanguageDropdown = () => {
  const langRef = useRef();
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.languageInfo.selectedLanguage);

  useEffect(() => {
    const languageOption = getInitialLanguage();

    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", languageOption.name);
    }

    dispatch(selectLanguageAction(languageOption));
  }, [dispatch]);

  const onSelectLanguage = (selectedLanguageEvent) => {
    dispatch(changeLanguagePreferenceAction(selectedLanguageEvent));

    if (selectedLanguageEvent.code === "it") {
      langRef.current({ target: { value: selectedLanguageEvent.code } });
      window.location.reload();
    } else {
      langRef.current({ target: { value: selectedLanguageEvent.code } });
    }
  };

  return (
    <>
      <Translator langRef={langRef} />
      {
        selectedLanguage && Object.keys(selectedLanguage).length > 0 &&
        <li className="nav-item dropdown">
          <NavDropdown
            title={
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}${selectedLanguage.logo}`}
                  alt={selectedLanguage.name}
                  style={{ width: "20px", height: "20px", marginRight: "5px" }}
                />
              </span>
            }
            id="navbarDropdown"
          >
            {
              LANGUAGES.map((elem) => (
                <NavDropdown.Item key={elem.name} onClick={() => onSelectLanguage(elem)}>
                  <img
                    src={`${process.env.PUBLIC_URL}${elem.logo}`}
                    alt={elem.name}
                    style={{ width: "20px", height: "20px", marginRight: "5px" }}
                  />
                  {elem.name}
                </NavDropdown.Item>
              ))
            }
          </NavDropdown>
        </li>
      }
    </>
  );
};

export default LanguageDropdown;
